import type { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/cart/get';
import { postToHamsClient } from 'util/mac/api/cart/post';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { selectSwitchedUser } from '../selectors';

export const order = (orderId: string, state: State) =>
  fetchWithParamValidation(({ id }) => getFromHamsClient(`${id}`, state), {
    id: orderId,
  });

export const source = (sourceParam: string, state: State) =>
  fetchWithParamValidation((src) => postToHamsClient('', state, undefined, { source: src }), {
    src: sourceParam,
  });

export const purchaseOrderNumber = (id: string, purchaseOrderNumberParam: string, state: State) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ identifier, updByEmail, orderNum }) =>
      postToHamsClient(`${identifier}/purchaseOrderNumber/${orderNum}`, state, {
        updatedByEmail: updByEmail,
      }),
    { identifier: id, orderNum: purchaseOrderNumberParam, updByEmail: email },
  );
};
export const cartByOrderNumber = (orderNumber: string, state: State) => {
  return fetchWithParamValidation(() => getFromHamsClient(`order/${orderNumber}`, state), {});
};
